(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["store-locator-page"]) return;
  try {
    
  document.querySelectorAll('[data-rg-store-grid]').forEach((grid) => {
    const section = grid.closest('.rg-stores');
    const input = section.querySelector('[data-rg-store-search]');
    const clear = section.querySelector('[data-rg-store-clear]');
    const empty = section.querySelector('[data-rg-store-empty]');
    const cards = Array.from(grid.querySelectorAll('[data-rg-store-card]'));
    const normalize = (value) => value.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const filterStores = () => {
      const query = normalize(input.value.trim());
      let visible = 0;
      cards.forEach((card) => {
        const match = !query || normalize(card.dataset.search).includes(query);
        card.hidden = !match;
        if (match) visible += 1;
      });
      clear.hidden = !query;
      empty.hidden = visible !== 0;
    };
    input.addEventListener('input', filterStores);
    clear.addEventListener('click', () => {
      input.value = '';
      filterStores();
      input.focus();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
